import numeral from "numeral";
export type QuickFact_T = {
  title: string;
  stat: string;
  metric: string;
};

function isDollarBasedTitle(title: string, metric: string) {
  if (title.includes("Exposure") && !metric.includes("Population")) {
    return true;
  }
  if (
    title.includes("Expected Annual Loss") &&
    metric !== "Population (Injuries & Fatalities)"
  ) {
    return true;
  } else return false;
}

export function formatNriQuickFacts(quickFacts: QuickFact_T[]) {
  return quickFacts?.map((quickFact) => {
    return {
      ...quickFact,
      stat: isDollarBasedTitle(quickFact.title, quickFact.metric)
        ? parseFloat(quickFact.stat) !== -9999
          ? numeral(quickFact.stat).format("$0.00a")
          : "N/A"
        : numeral(quickFact.stat).format("0.00a"),
    };
  });
}
